import { render, staticRenderFns } from "./Holding.vue?vue&type=template&id=9846b878&scoped=true"
import script from "./Holding.vue?vue&type=script&lang=js"
export * from "./Holding.vue?vue&type=script&lang=js"
import style0 from "./Holding.vue?vue&type=style&index=0&id=9846b878&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9846b878",
  null
  
)

export default component.exports